import { NgTemplateOutlet } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TypedComponentRendering } from '@core/jss-models';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import {
  ExperienceEditorComponent,
  ExperienceEditorLiveDirective,
  ExperienceEditorPreviewDirective,
} from '@core/experience-editor-components';
import { SkeletonLoadingCardComponent } from '@legacy/common-ui-shared';

import { ComponentTestingVariant } from '../ab-testing.model';
import type { ComponentTestingFields } from '../component-testing-container/component-testing-container.component';

@Component({
  selector: 'wl-component-testing',
  templateUrl: './component-testing.component.html',
  standalone: true,
  imports: [
    JssModule,
    SkeletonLoadingCardComponent,
    ExperienceEditorComponent,
    ExperienceEditorLiveDirective,
    ExperienceEditorPreviewDirective,
    NgTemplateOutlet,
  ],
})
export class ComponentTestingComponent {
  readonly variant = input.required<ComponentTestingVariant>();
  readonly rendering =
    input.required<TypedComponentRendering<ComponentTestingFields>>();

  readonly rendered = output<boolean>();

  onPlaceholderLoaded(track: boolean) {
    this.rendered.emit(track);
  }
}
